/* EZFeeder - High Conversion JS */
document.addEventListener('DOMContentLoaded', function () {

  /* ── Countdown Timer ── */
  function startCountdown() {
    var els = { h: document.getElementById('cd-h'), m: document.getElementById('cd-m'), s: document.getElementById('cd-s') };
    if (!els.h) return;
    var end = new Date();
    end.setHours(end.getHours() + 3, end.getMinutes() + 47, end.getSeconds() + 0);
    var saved = localStorage.getItem('ezf_countdown_end');
    if (saved && new Date(saved) > new Date()) end = new Date(saved);
    localStorage.setItem('ezf_countdown_end', end.toISOString());
    setInterval(function () {
      var diff = Math.max(0, end - new Date());
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      if (els.h) els.h.querySelector('.cd-val').textContent = String(h).padStart(2,'0');
      if (els.m) els.m.querySelector('.cd-val').textContent = String(m).padStart(2,'0');
      if (els.s) els.s.querySelector('.cd-val').textContent = String(s).padStart(2,'0');
    }, 1000);
  }
  startCountdown();

  /* ── Rotating Announcement Bar ── */
  var msgs = document.querySelectorAll('.announcement-msg');
  if (msgs.length > 1) {
    var idx = 0;
    var wrap = msgs[0].parentElement;
    setInterval(function () {
      idx = (idx + 1) % msgs.length;
      wrap.style.transform = 'translateX(-' + (idx * 100) + '%)';
    }, 4000);
  }

  /* ── Social Proof Toasts ── */
  var toasts = [
    { name: 'Margaret H.', loc: 'Minnesota', time: '2 minutes ago' },
    { name: 'Robert K.',   loc: 'Wisconsin',  time: '11 minutes ago' },
    { name: 'Carol B.',    loc: 'Iowa',        time: '34 minutes ago' },
    { name: 'Jim T.',      loc: 'Ohio',        time: '1 hour ago' },
    { name: 'Susan L.',    loc: 'Michigan',    time: '2 hours ago' },
    { name: 'David M.',    loc: 'Colorado',    time: '3 hours ago' }
  ];
  var toast = document.getElementById('sp-toast');
  if (toast) {
    var ti = 0;
    function showToast() {
      var t = toasts[ti % toasts.length];
      toast.querySelector('.sp-name').textContent = t.name + ' from ' + t.loc;
      toast.querySelector('.sp-time').textContent = t.time;
      toast.classList.add('show');
      setTimeout(function () { toast.classList.remove('show'); }, 4000);
      ti++;
      setTimeout(showToast, 12000 + Math.random() * 8000);
    }
    setTimeout(showToast, 5000);
  }

  /* ── Sticky ATC ── */
  var stickyAtc = document.querySelector('.sticky-atc');
  var atcBtn = document.querySelector('.atc-btn');
  if (stickyAtc && atcBtn) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        stickyAtc.classList.toggle('visible', !e.isIntersecting);
      });
    }, { threshold: 0.5 });
    obs.observe(atcBtn);
  }

  /* ── Accordion ── */
  document.querySelectorAll('.accordion-header').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var body = this.nextElementSibling;
      var open = this.classList.contains('active');
      document.querySelectorAll('.accordion-header').forEach(function (b) {
        b.classList.remove('active');
        b.nextElementSibling.classList.remove('open');
      });
      if (!open) { this.classList.add('active'); body.classList.add('open'); }
    });
  });

  /* ── FAQ ── */
  document.querySelectorAll('.faq-question').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var ans = this.nextElementSibling;
      var open = this.classList.contains('active');
      document.querySelectorAll('.faq-question').forEach(function (b) {
        b.classList.remove('active');
        b.nextElementSibling.classList.remove('open');
      });
      if (!open) { this.classList.add('active'); ans.classList.add('open'); }
    });
  });

  /* ── Qty Buttons ── */
  document.querySelectorAll('.qty-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var inp = this.parentElement.querySelector('.qty-input');
      var v = parseInt(inp.value) || 1;
      inp.value = this.dataset.action === 'minus' ? Math.max(1, v - 1) : v + 1;
    });
  });

  /* ── Thumb Gallery ── */
  document.querySelectorAll('.thumb-strip img').forEach(function (img) {
    img.addEventListener('click', function () {
      var main = document.getElementById('mainProductImg');
      if (main) main.src = this.src.replace(/width=\d+/, 'width=800');
      document.querySelectorAll('.thumb-strip img').forEach(function (i) { i.classList.remove('active'); });
      this.classList.add('active');
    });
  });

  /* ── Color Swatches ── */
  document.querySelectorAll('.swatch').forEach(function (sw) {
    sw.addEventListener('click', function () {
      document.querySelectorAll('.swatch').forEach(function (s) { s.classList.remove('active'); });
      this.classList.add('active');
      var sel = document.querySelector('.variant-select');
      if (sel) {
        var target = this.dataset.value;
        for (var i = 0; i < sel.options.length; i++) {
          if (sel.options[i].value === target || sel.options[i].text.toLowerCase().includes(target)) {
            sel.selectedIndex = i; break;
          }
        }
      }
    });
  });

  /* ── Exit Intent Popup ── */
  var popup = document.getElementById('exit-popup');
  var shown = sessionStorage.getItem('ezf_popup_shown');
  if (popup && !shown) {
    document.addEventListener('mouseleave', function handler(e) {
      if (e.clientY < 10) {
        popup.classList.add('show');
        sessionStorage.setItem('ezf_popup_shown', '1');
        document.removeEventListener('mouseleave', handler);
      }
    });
    popup.querySelector('.exit-popup-close').addEventListener('click', function () { popup.classList.remove('show'); });
    popup.querySelector('.exit-popup-skip').addEventListener('click', function () { popup.classList.remove('show'); });
    popup.addEventListener('click', function (e) { if (e.target === popup) popup.classList.remove('show'); });
  }

  /* ── Mobile Menu ── */
  var toggle = document.querySelector('.mobile-menu-toggle');
  var nav = document.querySelector('.nav-links');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.style.display === 'flex';
      nav.style.display = open ? 'none' : 'flex';
      if (!open) {
        Object.assign(nav.style, { flexDirection:'column', position:'absolute', top:'100%', left:'0', right:'0', background:'#fff', padding:'16px 24px', boxShadow:'0 8px 24px rgba(0,0,0,0.1)', zIndex:'999' });
      }
    });
  }

});
